import React from 'react'
import Text from './Text'
import { Icon } from '@iconify/react'

export default function DownloadRow({title,href}) {
  return (
    <a
        download
        href={href}
        target="_blank"
        rel="noreferrer"
      >
    <div
    className={
      "flex flex-row w-full items-center justify-between bg-lightGrey mb-4 rounded-button p-5"
    }
  >
    <Text
      subtitle
      text={title}
      className="w-11/12 md:w-auto"
    />

    <div className="w-1/12 md:w-auto">
      
        <Icon
          icon={"ri:file-download-fill"}
          className="text-orange text-sectionTitle md:text-title"
        />
    </div>
  </div>

      </a>
  )
}
